import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Loader } from '@keethealth/keet-ui';

import ContentItem from 'common/ContentItem';

export class AssignedList extends Component {
  static defaultProps = {
    filteredActivities: [],
  }

  static propTypes = {
    filteredActivities: PropTypes.arrayOf(PropTypes.shape({
      plannable: PropTypes.shape({
        title: PropTypes.string,
      }),
    })),
    loading: PropTypes.bool.isRequired,
  }

  renderContent = (item) => {
    const { id, plannable, status, updatedAt } = item;
    const isCompleted = status === 'completed';
    const isQuestionnaire = plannable && plannable.__typename === 'Questionnaire';
    const disabled = (isQuestionnaire && isCompleted) || _.isEmpty(plannable);
    return (
      <ContentItem
        key={id}
        id={id}
        type={plannable ? plannable.__typename.toLowerCase() : 'missing'}
        completed={isCompleted}
        faded={isCompleted || disabled}
        completedAt={updatedAt}
        name={plannable ? plannable.title : 'Missing Content'}
        description={plannable ? plannable.description : 'This content has been deleted.'}
        disabled={disabled}
      />
    );
  }

  render() {
    const { filteredActivities, loading } = this.props;
    if (loading) return <Loader />;

    const carePlan = filteredActivities;
    const isEmpty = carePlan.length === 0;

    return (
      <div className="w-100 overflow-auto ph4-ns ph0">
        {carePlan.map(this.renderContent)}
        {isEmpty &&
          <div className="pa4 tc">
            <h4 className="mt4 mb0">{'This is where you will find new tasks to complete.'}</h4>
          </div>
        }
      </div>
    );
  }
}

export default AssignedList;
